import React from "react";
import styled from "styled-components";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";
import { DropDown as DropDownContext } from "core/DropDown/index.js";

// components
import AuthProfile from "core/SiteHeader/components/Auth/AuthProfile";
import AuthMenus from "core/SiteHeader/components/Auth/AuthMenus";
import LogoutButton from "core/SiteHeader/components/LogoutButton.js";
import MarketingMessage from "core/SiteHeader/components/Auth/MarketingMessage.js";

//styles
import { convertPxToRem } from "frontend/components/helpers";
import colors from "core/colors";

const ListItemStyled = styled.li`
    display: block;
    padding: 0rem ${convertPxToRem(32)};
`;

const AuthWrapperStyled = styled(ListItemStyled)`
    padding-top: ${convertPxToRem(30)};
    padding-bottom: ${convertPxToRem(24)};
    border-bottom: solid ${convertPxToRem(1)}
        ${({ $borderColor }) => $borderColor};
`;
const LinksWrapperStyled = styled(ListItemStyled)`
    padding: ${convertPxToRem(30)} ${convertPxToRem(32)} 0rem;
    display: flex;
    gap: ${convertPxToRem(32)};
`;
const LogOutWrapperStyled = styled(ListItemStyled)`
    padding-top: ${convertPxToRem(32)};
    padding-bottom: ${convertPxToRem(30)};
`;

// component
const DropDown = () => {
    const { isDarkMode, hasMounted } = useSiteHeader();
    if (!hasMounted) return null;

    const borderColor = isDarkMode
        ? colors.secondary.basalt
        : colors.primary.scheifer;

    return (
        <DropDownContext>
            <AuthWrapperStyled $borderColor={borderColor}>
                <AuthProfile />
                <MarketingMessage $isDarkMode={isDarkMode} />
            </AuthWrapperStyled>
            <LinksWrapperStyled>
                <AuthMenus />
            </LinksWrapperStyled>
            <LogOutWrapperStyled>
                <LogoutButton />
            </LogOutWrapperStyled>
        </DropDownContext>
    );
};

export default DropDown;
